var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('preview',{attrs:{"url":"https://img2.tutubox.cn/EuropeThree.png","markers":_vm.marker},on:{"clickMarker":_vm.clickArrow}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }